var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLicenseStandard = function SvgLicenseStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DF5C2",
    d: "m.235 10.781 1.683-2.92 6.317 1.775v3.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E59B",
    d: "m16.235 10.781-1.683-2.92-6.318 1.775v3.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A94FF",
    d: "m2.54 6.842 1.948-3.371L8.263 4.56v3.85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#477BFF",
    d: "M13.932 6.799 11.99 3.506 8.262 4.565v3.843z"
  })));
};
export default SvgLicenseStandard;